package com.patronat.top.dto.venues

import kotlinx.serialization.Serializable

@Serializable
enum class VenueGroup {
    FOOD,
    SHOPPING,
    BEAUTY,
    HEALTH,
    AUTO,
    HOME,
    EDUCATION,
    BUSINESS,
    IT_MEDIA,
    LOGISTICS,
    ENTERTAINMENT,
    PETS,
    HOUSEHOLD,
    EVENTS,
    TRAVEL
}

@Serializable
enum class VenueCategory(val group: VenueGroup) {
    // 1. Ресторани, кафе, їжа
    RESTAURANT(VenueGroup.FOOD),
    COFFEE_SHOP(VenueGroup.FOOD),
    BAR_PUB(VenueGroup.FOOD),
    BAKERY_CONFECTIONERY(VenueGroup.FOOD),
    PIZZERIA(VenueGroup.FOOD),
    SUSHI_ASIAN(VenueGroup.FOOD),
    FAST_FOOD(VenueGroup.FOOD),
    STEAK_HOUSE(VenueGroup.FOOD),
    CATERING_DELIVERY(VenueGroup.FOOD),
    BREAKFAST_BRUNCH(VenueGroup.FOOD),

    // 2. Магазини та покупки
    GROCERY_SUPERMARKET(VenueGroup.SHOPPING),
    MEAT_DAIRY_SHOP(VenueGroup.SHOPPING),
    CLOTHING_SHOES(VenueGroup.SHOPPING),
    COSMETICS_PERFUMERY(VenueGroup.SHOPPING),
    ELECTRONICS(VenueGroup.SHOPPING),
    FURNITURE_DECOR(VenueGroup.SHOPPING),
    CONSTRUCTION_MATERIALS(VenueGroup.SHOPPING),
    PET_SHOP(VenueGroup.SHOPPING),
    BOOKSTORE_STATIONERY(VenueGroup.SHOPPING),
    FLOWER_SHOP(VenueGroup.SHOPPING),

    // 3. Краса та догляд
    HAIRDRESSER(VenueGroup.BEAUTY),
    BARBERSHOP(VenueGroup.BEAUTY),
    MANICURE_PEDICURE(VenueGroup.BEAUTY),
    COSMETOLOGY(VenueGroup.BEAUTY),
    SPA_MASSAGE(VenueGroup.BEAUTY),
    SOLARIUM(VenueGroup.BEAUTY),
    TATTOO_PIERCING(VenueGroup.BEAUTY),
    LASER_HAIR_REMOVAL(VenueGroup.BEAUTY),

    // 4. Медицина та здоров’я
    CLINIC_GP(VenueGroup.HEALTH),
    DENTISTRY(VenueGroup.HEALTH),
    LABORATORY(VenueGroup.HEALTH),
    AESTHETIC_MEDICINE(VenueGroup.HEALTH),
    VETERINARY_CLINIC(VenueGroup.HEALTH),
    PSYCHOTHERAPY(VenueGroup.HEALTH),
    PHARMACY(VenueGroup.HEALTH),
    OPTICS(VenueGroup.HEALTH),

    // 5. Авто
    CAR_SERVICE(VenueGroup.AUTO),
    CAR_WASH(VenueGroup.AUTO),
    AUTO_PARTS(VenueGroup.AUTO),
    TIRE_SERVICE(VenueGroup.AUTO),
    CAR_DEALERSHIP(VenueGroup.AUTO),
    TUNING_DETAILING(VenueGroup.AUTO),
    CAR_INSURANCE(VenueGroup.AUTO),
    TAXI_RENTAL(VenueGroup.AUTO),

    // 6. Нерухомість, будівництво та ремонт
    CONSTRUCTION_COMPANY(VenueGroup.HOME),
    RENOVATION_DESIGN(VenueGroup.HOME),
    PLUMBING_ELECTRIC(VenueGroup.HOME),
    WINDOWS_DOORS(VenueGroup.HOME),
    HEATING_AC(VenueGroup.HOME),
    REAL_ESTATE_AGENCY(VenueGroup.HOME),
    CLEANING(VenueGroup.HOME),
    WASTE_REMOVAL(VenueGroup.HOME),

    // 7. Освіта та розвиток
    LANGUAGE_COURSES(VenueGroup.EDUCATION),
    TUTORING(VenueGroup.EDUCATION),
    KINDERGARTEN_SCHOOL(VenueGroup.EDUCATION),
    UNIVERSITY_COLLEGE(VenueGroup.EDUCATION),
    ONLINE_COURSES(VenueGroup.EDUCATION),
    MUSIC_ART_SCHOOL(VenueGroup.EDUCATION),
    TRAINING_CENTER(VenueGroup.EDUCATION),

    // 8. Бізнес, фінанси, юридичні послуги
    BANK_CREDIT(VenueGroup.BUSINESS),
    ACCOUNTING_AUDIT(VenueGroup.BUSINESS),
    LEGAL_NOTARY(VenueGroup.BUSINESS),
    INSURANCE_COMPANY(VenueGroup.BUSINESS),
    TAX_CONSULTING(VenueGroup.BUSINESS),
    BUSINESS_CONSULTING(VenueGroup.BUSINESS),
    COWORKING(VenueGroup.BUSINESS),

    // 9. IT, маркетинг та медіа
    WEB_DEVELOPMENT(VenueGroup.IT_MEDIA),
    MARKETING_SMM_SEO(VenueGroup.IT_MEDIA),
    PRODUCTION_PHOTO_VIDEO(VenueGroup.IT_MEDIA),
    IT_SUPPORT(VenueGroup.IT_MEDIA),
    COPYWRITING_TRANSLATION(VenueGroup.IT_MEDIA),
    UX_UI_DESIGN(VenueGroup.IT_MEDIA),

    // 10. Логістика та послуги
    COURIER_SERVICE(VenueGroup.LOGISTICS),
    POST_DELIVERY(VenueGroup.LOGISTICS),
    EQUIPMENT_RENTAL(VenueGroup.LOGISTICS),
    MOVING_SERVICE(VenueGroup.LOGISTICS),
    WAREHOUSING(VenueGroup.LOGISTICS),

    // 11. Розваги та дозвілля
    CINEMA(VenueGroup.ENTERTAINMENT),
    BOWLING_BILLIARDS(VenueGroup.ENTERTAINMENT),
    QUEST_VR(VenueGroup.ENTERTAINMENT),
    NIGHT_CLUB(VenueGroup.ENTERTAINMENT),
    KIDS_ENTERTAINMENT(VenueGroup.ENTERTAINMENT),
    TOURISM_HOTELS(VenueGroup.ENTERTAINMENT),

    // 12. Домашні улюбленці
    VET_SERVICES(VenueGroup.PETS),
    GROOMING(VenueGroup.PETS),
    PET_HOTEL(VenueGroup.PETS),
    DOG_TRAINING(VenueGroup.PETS),

    // 13. Побутові послуги
    DRY_CLEANING(VenueGroup.HOUSEHOLD),
    SHOE_CLOTHES_REPAIR(VenueGroup.HOUSEHOLD),
    TECH_REPAIR(VenueGroup.HOUSEHOLD),
    KEYS_LOCKS(VenueGroup.HOUSEHOLD),
    PRINTING_COPY(VenueGroup.HOUSEHOLD),

    // 14. Події та свята
    EVENT_AGENCY(VenueGroup.EVENTS),
    EVENT_PHOTO_VIDEO(VenueGroup.EVENTS),
    HOST_DJ(VenueGroup.EVENTS),
    DRESS_RENTAL(VenueGroup.EVENTS),
    HALL_RENTAL(VenueGroup.EVENTS),
    EVENT_CATERING(VenueGroup.EVENTS),

    // 15. Подорожі та транспорт
    TRAVEL_AGENCY(VenueGroup.TRAVEL),
    HOTEL_HOSTEL(VenueGroup.TRAVEL),
    VEHICLE_RENTAL(VenueGroup.TRAVEL),
    TRANSFER_TAXI(VenueGroup.TRAVEL),
    GAS_STATION_EV(VenueGroup.TRAVEL)
}